<template>
  <div class="p-2 bg-gray-200 dark:bg-gray-900">
    <div class="w-full">
      <div class="h-full p-2 bg-gray-50 dark:bg-gray-800 rounded shadow-sm">
        <!-- Tabs -->
        <div class="flex border-b border-gray-300 mb-2">
          <button
            v-for="tab in tabs"
            :key="tab.key"
            class="px-4 py-2 text-sm font-medium transition-colors"
            :class="activeTab === tab.key
              ? 'border-b-2 border-red-600 text-red-600'
              : 'text-gray-500 hover:text-gray-700'"
            @click="activeTab = tab.key"
          >
            {{ tab.label }}
          </button>
        </div>

        <!-- Tab Content - Her tab orijinal sayfanın birebir aynısı -->
        <PlanningModule v-if="activeTab === 'spot'" :isArchived="true" />
        <CollectivePlanningModule v-if="activeTab === 'bulk'" :isArchived="true" />
        <ShipEvacuationModule v-if="activeTab === 'ship'" :isArchived="true" />
        <StorageEvacuationModule v-if="activeTab === 'storage'" :isArchived="true" />
      </div>
    </div>
  </div>
</template>

<script>
import PlanningModule from "../planning/index.vue";
import CollectivePlanningModule from "../collectivePlanning/index.vue";
import ShipEvacuationModule from "../shipEvacuation/index.vue";
import StorageEvacuationModule from "../storageEvacuation/index.vue";

export default {
  name: "archive-module",
  components: {
    PlanningModule,
    CollectivePlanningModule,
    ShipEvacuationModule,
    StorageEvacuationModule,
  },
  data() {
    return {
      activeTab: "spot",
      tabs: [
        { key: "spot", label: "Spot" },
        { key: "bulk", label: "Toplu" },
        { key: "ship", label: "Gemi" },
        { key: "storage", label: "Depo" },
      ],
    };
  },
};
</script>
